import React from 'react';

const BookingReference = ({ bookingReference, createdAt, formatDate }) => {
  return (
    <div className="bg-surface border rounded-lg p-2 sm:p-3">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
        <div className="min-w-0 flex-1">
          <h2 className="text-sm sm:text-base md:text-lg font-bold text-black mb-0.5 break-words">
            Booking #{bookingReference}
          </h2>
          <p className="text-xs text-gray-600 break-words">
            Created on {formatDate(createdAt)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingReference;

